import { Skeleton } from '@design-system/Skeleton';
import { cn } from '@utils/styles';
import { isHexColor } from '@utils/checkHexCode';
import ProgressBar from '@design-system/ProgressBar';
import { ScoreDetail } from '@viome/viome-base/src/usecase/Health/Health.model';
import { HealthReferenceSection } from '@screens/HealthPages/HealthReferenceSection';

interface HeaderSectionProps {
  isLoading: boolean;
  l3Score: ScoreDetail;
  scoreId: number;
}

export const HealthL3HeaderDetails = ({
  l3Score,
  isLoading,
  scoreId,
}: HeaderSectionProps) => {
  const { title, rank_color: rankColor, rank, score } = l3Score || {};
  return (
    <div className="flex sm:flex-row flex-col w-full items-center my-12">
      <div className="flex md:flex-col items-start justify-between bg-transparent w-[48%] max-sm:w-full">
        <div>
          {isLoading ? (
            <Skeleton className="h-8 w-72 mb-2" />
          ) : (
            <h1 className="md:typography-d1 typography-d2 w-full lg:w-[90%] line-clamp-2">
              {title}
            </h1>
          )}
          {isLoading ? (
            <Skeleton className="h-5 w-40 mb-6" />
          ) : (
            <p
              className={cn(
                'typography-body text-left',
                !isHexColor(rankColor) && rankColor,
              )}
              style={isHexColor(rankColor) ? { color: rankColor } : undefined}
            >
              {rank}
            </p>
          )}
        </div>
      </div>
      <div className="text-primary w-[48%] max-sm:w-full flex items-center">
        <div className="w-full typography-footnote text-tertiary mt-3">
          <div className="flex justify-end">
            {isLoading ? (
              <Skeleton className="h-12 w-16 mb-4" />
            ) : (
              <h2 className="md:typography-num-large typography-d1 mb-1 sm:mt-0">
                {score}
              </h2>
            )}
          </div>
          <div>
            {isLoading ? (
              <Skeleton className="h-2 w-full rounded-full" />
            ) : (
              <ProgressBar progress={score} color={rankColor} />
            )}
          </div>
          <div className="flex items-center justify-between mt-3">
            <p>0</p>
            <div className="flex items-center justify-between">
              <HealthReferenceSection scoreId={scoreId} />
            </div>
            <p>100</p>
          </div>
        </div>
      </div>
    </div>
  );
};
